<template>
	<span id="dark-modal-container">
		<div id="dark-modal">
			<div id="modal-container">
				<div id="modal">
					<div id="close" @click="closeModal()">
						<i class="fa fa-times" aria-hidden="true"></i>
					</div>
					<p @click="closeModal">{{text}}</p>
					<div id="buttons">
						<input type="button" class="modalButton approve" value="אישור">
						<input type="button" class="modalButton cancel" value="ביטול">
					</div>
				</div>
			</div>
		</div>
	</span>
</template>
<script>
export default {
	props: ['onApprove','show', 'text', 'type'],
	name: 'Modal',
	data () {
		return {
			name: 'YO'
		}
	},
	methods: {
		closeModal: function(){
			$('#dark-modal').fadeOut(200);
		},
		showModal: function(){
			$('#dark-modal').fadeIn(200);
		},
		approve: function(){
			this.onApprove()
		}
	},
	created(){

	},
	watch: {
		show: 'showModal'
	}
}
</script>
<style lang="less" scoped>

#dark-modal-container{
}

p{
	padding: 15px 0px;
}

#dark-modal{
	font-size: 15px !important;
	font-family: 'Assistant';
	display: none;
	position: fixed;
	z-index: 8888;
	background: rgba(15, 15, 15, .9);
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
}

#modal-container{
	position: relative;
	width: 100%;
	height: 100%;
}

#modal{
	min-width: 490px;
	padding: 15px;
	background: #fff;
	box-shadow: 3px 3px 16px 0px rgba(15, 15, 15, .15);
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

#buttons{
	display: block;
	margin: 15px auto 0px;
	text-align: center;
}

.modalButton{
	display: inline-block;
	vertical-align: top;
	font-size: 15px;
	padding: 15px;
	text-align: center;
	width: 120px;
	border: 0px;
	outline: 0;
	max-width: 230px;
	cursor: pointer;
	transition: all 0.3s;
	margin-top: 25px;
	box-shadow: 1px 1px 3px 0px rgba(15, 15, 15 , .15), -1px -1px 3px 0px rgba(255, 255, 255 , .15);
	&:nth-of-type(2){
		margin-right: 35px;
	}
}

.btnColors(@color){
	color: @color;
	background: #fff;
	border-top: 1px solid lighten(#666, 2%);
	border-left: 1px solid lighten(#666, 2%);
	text-shadow: darken(#fafafa, 2%);
	&:hover{
		color: #fff;
		background: lighten(@color, 5%);
	}
	&:active{
		color: #fff;
		box-shadow: inset 1px 1px 3px 0px rgba(15, 15, 15 , .15), inset -1px -1px 3px 0px rgba(255, 255, 255 , .15);
		background: darken(@color, 5%);
	}
}
.approve{
	.btnColors(green);
}


.cancel{
	.btnColors(red);
}

#close{
	i{
		font-size: 18px;
	}
	cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal.vue